document.addEventListener("DOMContentLoaded", () => {
    const detailsList = document.querySelectorAll(".header__inline-menu details");
  
    detailsList.forEach(details => {
      const summary = details.querySelector("summary");
      const submenu = details.querySelector(".header__submenu");
  
      if (!summary || !submenu) return;
  
      let closeTimeout;
  
      const openMenu = () => {
        clearTimeout(closeTimeout);
        details.setAttribute("open", "");
      };
  
      const closeMenu = () => {
        closeTimeout = setTimeout(() => {
          details.removeAttribute("open");
        }, 200);
      };
  
      const preventToggle = (e) => {
        if (window.innerWidth >= 750) e.preventDefault();
      };
  
      summary.addEventListener("click", preventToggle);
  
      summary.addEventListener("mouseenter", () => {
        if (window.innerWidth >= 750) openMenu();
      });
      submenu.addEventListener("mouseenter", () => {
        if (window.innerWidth >= 750) openMenu();
      });
  
      summary.addEventListener("mouseleave", () => {
        if (window.innerWidth >= 750) closeMenu();
      });
      submenu.addEventListener("mouseleave", () => {
        if (window.innerWidth >= 750) closeMenu();
      });
    });
  
    window.addEventListener("resize", () => {
      // comportamento è gestito direttamente dal controllo di innerWidth
    });
  });